import React, { useRef } from 'react'
import HeroSection from './HeroSection'
import SubHeroSection from './SubHeroSection'
import Footer from './Footer'
import AttorneyHeroSection from './AttorneyHeroSection'
import HomeHeader from './HomeHeader'
import HomeToggleHero from './HomeToggleHero'
import SubscriptionSection from './SubscriptionSection'
import Faq from './Faq'
import MissionSection from './MissionSection'
import { useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { Context } from '../../Context/Context'
import { fetchAuthSession } from '@aws-amplify/auth'
import { ADMIN, checkIfLoggedInApi, CLIENT, PROFESSIONAL } from '../../Constants'
import { DEFAULTAVATAR } from '../../Constants'
import axios from 'axios'

import awsConfig  from '../../aws_config'
import {Amplify} from "aws-amplify";

import { record } from 'aws-amplify/analytics';

import AssistantSection from './AssistantSection'
import AttorneyAssistantSection from './AttorneyAssistantSection'
import { Credentials } from 'aws-amplify';
import ReactGA from 'react-ga4';
import ClientStatistics from 'Components/Client/Cases/CasesTable/ClientStatistics'
import HeroSectionAI from './HeroSectionAI'
import AttorneyTeamupHeroSection from './AttorneyTeamupHeroSection'
import AttorneyCaseSummarySection from './AttorneyCaseSummarySection'

// Launch flag: for now, logged-in users see the same public HomeToggleHero homepage as
// logged-out visitors instead of the role-specific dashboard below. The dashboard JSX is kept
// in place (not deleted) so it's a one-line flip to bring back later.
const SHOW_LOGGED_IN_DASHBOARD = false

function HomePage() {
  
  // useEffect(() => {
    
  //   const testTrack = async () => {
  //     try {
  //       await record({
  //         name: 'HomePageVisit',
  //         attributes: {
  //           testAttribute: 'testValue',
  //         },
  //         metrics: {
  //           testMetric: 1,
  //         },
  //       });
  //       console.log('✅ Event recorded');
  //     } catch (err) {
  //       console.error('❌ Record failed:', err);
  //     }
  //   };
  //   testTrack();

  // }, []);
    
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

    const navigate = useNavigate();
    const { makeApiCallFunc} = useContext(Context);
    const pricingRef = useRef(null);
    const accordionItems = [
        
        [
        
            {
              "title": "How does this platform work for clients?",
              "content": "Clients can create cases for free and receive requests from attorneys interested in helping them. Once approved, clients can communicate directly with their chosen attorney. Upon approval of the attorney and passing a conflicts check conducted by the attorney, clients can communicate directly with the attorney."
            },
            {
              "title": "Is it free to post a case?",
              "content": "Yes! Posting a case is completely free for clients."
            },
            {
              "title": "Can I choose which attorney sees my case?",
              "content": "Yes. Attorneys can request to view your case, and you decide who gets access."
            },
            {
              "title": "Are my case details private?",
              "content": "Yes. Only attorneys you approve will be able to view your case details. Also you can delete your case at any point in time."
            },
           
          
      ],
      [
            {
                "title": "How does this platform work for attorneys?",
                "content": "Attorneys can request to view cases, and if approved by the client, they can start communicating and providing legal services."
            },
            {
                "title": "How much does it cost to subscribe?",
                "content": "Attorneys pay a low monthly subscription fee to access and request cases."
            },
            {
                "title": "Can I have assistants manage my cases?",
                "content": "Yes. Attorneys can assign assistants to help manage cases with restricted access to ensure data privacy and security."
            },
            {
                "title": "What kind of access do assistants have?",
                "content": "Assistants can view and manage case details as permitted by the attorney, but they do not have full attorney account privileges."
            },
            {
                "title": "How do I get clients?",
                "content": "Attorneys can browse cases posted by clients and send a request to view case details. Clients decide whether to approve or decline the request."
            },
            {
                "title": "Is there a limit on how many cases I can request?",
                "content": "No, You can request as many cases as you want. However SOS cases and cases posted recently can be viewed only by subscribed users."
            }
      ],
      [
        {
          "title": "How does this platform involve legal assistants?",
          "content": "This platform allows legal assistants to connect with licensed attorneys within their firm, assist with case management, and receive case-related notifications."
        },
        {
          "title": "How do legal assistants register on the platform?",
          "content": "Legal assistants can sign up on our website by providing their email address, which must match the domain of their law firm."
        },
        {
          "title": "How do legal assistants get linked to attorneys?",
          "content": "Legal assistants can request to be added by attorneys, or attorneys can directly add them to their team."
        },
        {
          "title": "Can a legal assistant work with multiple attorneys?",
          "content": "Yes, legal assistants can assist multiple attorneys, but all attorneys must be within the same law firm (i.e., the email domain must match the firm's domain)."
        },
        {
          "title": "What happens once a legal assistant is added to an attorney’s team?",
          "content": "Once added, the assistant will start seeing the attorney’s case list and receive case-related notifications."
        },
        {
          "title": "What types of notifications do legal assistants receive?",
          "content": "Notifications include case updates"
        },
        {
          "title": "Can legal assistants switch between different attorneys?",
          "content": "Yes, as long as all attorneys belong to the same firm, legal assistants can assist multiple attorneys within the platform."
        },
        {
          "title": "What happens if a legal assistant changes firms?",
          "content": "If a legal assistant joins a new firm, they must register with a new email that matches the new firm’s domain and get added to their new team of attorneys."
        },
      ]
      
    ]
    const [isResponseReceived, setIsResponseReceived] = useState(false);
    const {updateLoggedinData, setUserDetails, setAwaitCount,userDetails, setShowLoading, setNotificationCount, selectedMenuItem, setSelectedMenuItem} = useContext(Context);
    useEffect(() => 
      {
          fetchAuthSession().then((session) => {
              const accessToken = session.tokens.accessToken.toString();
              getUserDetails(accessToken);
          }
          ).catch(async(error) => {
              console.log("Error", error)
              setIsResponseReceived(true);
              setUserDetails({});
              // navigate("/signin");
          }
          );
      },[]);
      const getUserDetails = async(accessToken) => 
        {
            if(accessToken)
            {
                try {
                    setShowLoading(true);

                    const data = await axios.get(checkIfLoggedInApi, {headers: {'Authorization': accessToken}});
                    if({data})
                    {
                        setShowLoading(false);
                        setUserDetails(data?.data);
                        setNotificationCount(data?.data?.notifications);
                        setIsResponseReceived(true);
                        console.log("data", data.data);
                    }
                    else
                    {
                        setShowLoading(false);
                        setIsResponseReceived(true);
                    }
                    
                }  
                catch (error)
                {
                    setIsResponseReceived(true);
                    console.log("session expired. login again")
                }
            }
        }
  return (
    <div className='w-full h-full bg-white  '>
       {userDetails?.email && SHOW_LOGGED_IN_DASHBOARD && <HomeHeader  pricingRef={pricingRef}/>}
       <div className='w-full h-full  '>
       
       {(userDetails?.email && SHOW_LOGGED_IN_DASHBOARD ?
            <>
            <div className='flex items-center border-b-1  justify-left mb-10 mt-10 lg:mt-20'>
                <div className='text-3xl flex'>
                    <div className={'flex mx-4 w-12 h-12 border ring-2 rounded-full ring-gray-400' + (userDetails.verified ? ' ring-tan' : '')}
                    >
                        <img src={userDetails.profilePic && userDetails.profilePic !== "" ? userDetails.profilePic : DEFAULTAVATAR} alt="Preview" />
                    </div>
                </div>
                <div className='flex flex-col w-full h-max'>
                    <div className='text-sm lg:text-3xl mb-1'>
                    Welcome back, {userDetails?.firstName} {userDetails?.lastName}
                    </div>

                    {userDetails?.role === ADMIN ?
                    <div className='text-sm lg:text-lg'>
                        Start approving users with their attorney profiles
                    </div>
                    :
                    (userDetails?.role === CLIENT ?
                    <div className='text-sm lg:text-lg'>
                        Create your case and find a law firm today 
                    </div>
                    :
                    <div className='text-sm lg:text-lg'>
                        Search for cases matching your expertise
                    </div>)
                            } 
                </div>
            </div>
           {
            userDetails?.role === CLIENT ?
            <>
              <ClientStatistics/>
              <SubHeroSection/>
              <MissionSection/>
              <Faq accordionItems={accordionItems}/>
            </>
            :
            (userDetails.isUserAssistant && userDetails.role === PROFESSIONAL ? 
            <>
                <AssistantSection/>
               <MissionSection/>
               <Faq accordionItems={accordionItems}/> 
            </>
            :
            (userDetails.role === PROFESSIONAL ?
            <>
              
              <AttorneyHeroSection/>
              <SubscriptionSection pricingRef={pricingRef}/>
              <AttorneyCaseSummarySection/>
              <AttorneyTeamupHeroSection/>
              <AttorneyAssistantSection/>
              <MissionSection/>
              <Faq accordionItems={accordionItems}/>
            </>
            :
              userDetails.role === ADMIN ?
              <MissionSection/>  
              :
              ''
            ))
            }
        </>
        :
        <HomeToggleHero/>)
       }
       {userDetails?.email && SHOW_LOGGED_IN_DASHBOARD && <Footer/>}
       </div>
      
    </div>
  )
}

export default HomePage
